/**
 * KST (Korea Standard Time) = UTC+9 — Day-boundary utility
 * Used for GiftBox daily reset: "today" and "midnight" are defined by UTC+9 only.
 *
 * All logic uses UTC + (UTC+9) offset. Device timezone is ignored; same result
 * for users in any country.
 */

const MS_PER_HOUR = 60 * 60 * 1000;
const MS_PER_DAY = 24 * MS_PER_HOUR;
/** KST = UTC+9. Applied consistently for all "today" / "next midnight" calculations. */
const UTC_PLUS_9_MS = 9 * MS_PER_HOUR;

// 1. Get KST Today's Date String (YYYY-MM-DD) — UTC+9 calendar date
export function getKSTTodayStr() {
    const nowMs = Date.now();
    const kstMs = nowMs + UTC_PLUS_9_MS;
    const kst = new Date(kstMs);
    const y = kst.getUTCFullYear();
    const m = kst.getUTCMonth() + 1;
    const d = kst.getUTCDate();
    return `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
}

// 2. Get Next KST Midnight in ISO String (UTC Format) — next 00:00 in UTC+9
export function getNextKSTMidnightISO() {
    const nowMs = Date.now();
    // Today 00:00 (UTC+9) in UTC ms; then add one day for "next midnight"
    const kstDayStartMs = Math.floor((nowMs + UTC_PLUS_9_MS) / MS_PER_DAY) * MS_PER_DAY - UTC_PLUS_9_MS;
    const nextKSTMidnightMs = kstDayStartMs + MS_PER_DAY;
    return new Date(nextKSTMidnightMs).toISOString();
}
